// angular imports
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// cc-common imports
import { IconConstants, Utils } from 'cc-common';

// devextreme imports
import { DxDataGridComponent, DxPopupComponent } from 'devextreme-angular';

// service imports
import { FileHelperService } from '../../../_services/shared-services/file-helper.service';

// model imports
import { EmailAttachmentRawDto } from '../../../ciramail-module/_models/email-composer/email-attachment-raw-dto';

@Component({
    selector: 'app-architectural-application-email-attachment-selector',
    templateUrl: './architectural-application-email-attachment-selector.component.html',
    styleUrls: ['./architectural-application-email-attachment-selector.component.scss']
})
export class ArchitecturalApplicationEmailAttachmentSelectorComponent implements OnInit {
    @ViewChild('attachmentSelectorPopup', { static: false }) attachmentSelectorPopup: DxPopupComponent;
    @ViewChild('attachmentGrid', { static: false }) attachmentGrid: DxDataGridComponent;

    @Input() attachments: Array<EmailAttachmentRawDto>;

    @Output() onClose = new EventEmitter<any>();
    @Output() onAttachmentSelect = new EventEmitter<string[]>();

    visible = false;
    isRowSelected = false;

    iconCancel = IconConstants.CANCEL;
    iconAttachment = IconConstants.ATTACHMENT;

    constructor(private readonly fileHelperService: FileHelperService) {}

    ngOnInit() {
        this.show();
    }

    show(): void {
        this.visible = true;
    }

    onShown(): void {
        this.attachmentSelectorPopup.instance.repaint();
    }

    onHidden(): void {
        this.closeSelector();
    }

    onCancel(): void {
        this.closeSelector();
    }

    onSelect(): void {
        this.prepareAttachments();
    }

    onGridSelection(): void {
        const selectedRows = this.attachmentGrid.instance.getSelectedRowsData();
        if (Utils.notNullOrEmpty(selectedRows)) {
            this.isRowSelected = true;
        } else {
            this.isRowSelected = false;
        }
    }

    getFileIcon(fileName: string): string {
        return this.fileHelperService.getFileIcon(fileName);
    }

    private prepareAttachments(): void {
        const selectedRows = this.attachmentGrid.instance.getSelectedRowsData();

        if (Utils.notNullOrEmpty(selectedRows)) {
            this.onAttachmentSelect.emit(selectedRows);
            setTimeout(() => this.closeSelector(), 100);
        }
    }

    private closeSelector(): void {
        this.onClose.emit();
    }
}
